import React from 'react';
import cx from 'classnames';
import { TertiaryButton } from '@JohnLewisPartnership/jl-design-system/dist/elements/button/Button';
import { ReactComponent as WishlistIcon } from '../../assets/icons/wishlist.svg';
import styles from './AddToWishListIconButton.module.scss';
import Cookies from 'js-cookie';
import { redirectToSignIn } from '../../helpers/redirect/redirect';
import { getExperiencesFromWindow, isFlagSet } from '../../helpers/featureFlags/featureFlags';
import { FEATURE_FLAGS } from '../../helpers/featureFlags/constants';
import { postMonetateImpressionByName } from '../../helpers/monetate/monetate';
import { GUEST_WISH_LIST_EXPERIENCE } from '../../stores/constants';

const Wishlist24PxIcon: React.FC = () => <WishlistIcon />;
Wishlist24PxIcon.displayName = 'Wishlist24PxIcon';
export interface AddToWishListIconButtonProps {
    product?: WishListIconProduct;
    inWishList?: boolean;
    isSubmitting?: boolean;
    handleOnClick: (product: WishListIconProduct, remove: boolean) => Promise<void>;
    mode?: string;
}

export const AddToWishListIconButton: React.FC<AddToWishListIconButtonProps> = ({
    handleOnClick,
    product,
    inWishList = false,
    isSubmitting = false,
    mode = undefined,
}: AddToWishListIconButtonProps) => {
    if (!product) return null;

    return (
        <TertiaryButton
            IconComponent={Wishlist24PxIcon}
            aria-label="Add to wish list"
            data-testid="add-to-wish-list-button-icon"
            id={product.id}
            small
            tabIndex={0}
            onClick={(): void => {
                const windowExperiences = getExperiencesFromWindow();
                const isGuest = !Cookies.get('shopperId');

                if (isGuest) {
                    postMonetateImpressionByName(GUEST_WISH_LIST_EXPERIENCE, windowExperiences);
                }

                if (isGuest && !isFlagSet(FEATURE_FLAGS.GUEST_WISHLIST)) {
                    // Guest user without guest wishlist feature flag
                    redirectToSignIn(product.id, mode);
                    return;
                }
                handleOnClick?.(product, inWishList);
            }}
            disabled={isSubmitting}
            className={cx(styles.addToWishListIcon, {
                [styles.active]: inWishList,
                [styles.loading]: isSubmitting,
            })}
        >
            {inWishList ? 'Added to wishlist' : 'Add to wishlist'}
        </TertiaryButton>
    );
};

export default AddToWishListIconButton;
